import React from 'react';

import styled from 'styled-components';

export interface ButtonProps {
  state: 'default' | 'hover' | 'press' | 'disabled';
  backgroundColor?: string;
  label: string;
  btnStyle?: 'fill' | 'line'; // 버튼 스타일을 'fill' 또는 'line'으로 설정
  onClick?: () => void;
  disabled?: boolean;
}

/** Primary UI component for user interaction */
const Button = ({ backgroundColor, label, btnStyle = 'fill', state, ...props }: ButtonProps) => {
  return (
    <SButton state={state} btnStyle={btnStyle} type="button" style={{ backgroundColor }} {...props}>
      {label}
    </SButton>
  );
};

const SButton = styled.button<{ state: 'default' | 'hover' | 'press' | 'disabled'; btnStyle: 'fill' | 'line' }>`
  padding: 12px 0;
  width: 260px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  gap: 8px;
  border-radius: 8px;
  text-align: center;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: Pretendard;
  ${({ theme }) => theme.font.body1_m};
  color: ${({ theme }) => theme.color.static.white};
  transition: 0.2s;

  ${({ theme, btnStyle, state }) => {
    if (btnStyle === 'fill') {
      return `
        background: ${state === 'default' ? theme.color.static.primary : state === 'hover' ? theme.palette.aquamarine[55] : state === 'press' ? theme.palette.aquamarine[60] : theme.color.buttons.disable};
        &:hover {
          background: ${state !== 'disabled' ? theme.palette.aquamarine[55] : theme.color.buttons.disable};
        }
        &:active {
          background: ${state !== 'disabled' ? theme.palette.aquamarine[60] : theme.color.buttons.disable};
        }
      `;
    } else if (btnStyle === 'line') {
      return `
        ${theme.font.body1_r} !important;
        background: ${state === 'default' ? 'transparent' : state === 'hover' ? theme.palette.neutral[10] : theme.palette.neutral[15]};
        border: 1px solid ${theme.palette.neutral[30]};
        color: ${state === 'disabled' ? theme.color.text.TXT_0 : theme.color.text.TXT_1};
        &:hover {
          background: ${state !== 'disabled' ? theme.palette.neutral[10] : 'transparent'};
        }
        &:active {
          background: ${state !== 'disabled' ? theme.palette.neutral[15] : 'transparent'};
        }
      `;
    }
  }}

  &:disabled {
    background: ${({ theme }) => theme.color.buttons.disable};
    border: 1px solid ${({ theme }) => theme.color.buttons.disable};
  }
`;

export default Button;
